import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
`;

const Column = styled.ul`
  --columns: 4;

  display: flex;
  flex-direction: column;
  padding: 0 ${fluid(0, 24, Device.DesktopLarge, Device.ActualDesktop)};

  @media ${from(Device.DesktopLarge)} {
    --columns: 5;
  }

  &:first-of-type {
    gap: 8px;
    padding-left: 0;
    min-width: 25vw;
  }

  &:nth-child(2) {
    display: block;
    width: 100%;
    columns: auto var(--columns);
    padding: 0;

    > li {
      display: contents;

      > ul {
        &[data-visible='false'] {
          display: none;
        }

        &[data-visible='true'] {
          display: block;
          width: auto;
          min-width: calc(20% - 10px);
          margin-bottom: 10px;
          break-inside: avoid;

          // Sets min height for the column to force columns to wrap into 4 columns
          &[data-force-four-columns='true'] {
            min-height: 400px;
          }

          @media ${from(Device.DesktopLarge)} {
            // Sets min height for the column to force columns to wrap into 5 columns
            &[data-force-five-columns='true'] {
              min-height: 400px;
            }
          }

          // Sets min width for the column to force columns to wrap into 2 columns
          &[data-split-columns='true'] {
            position: relative;
            columns: auto 2;
            min-width: 184%;
            break-after: column;
            padding-top: 30px;

            @media ${from(Device.ActualDesktop)} {
              min-width: 200%;
            }

            li:first-child {
              position: absolute;
              top: 0;
              left: 0;
            }
          }
        }

        li {
          padding: 5px;

          &:first-child {
            ${fonts.helvetica['73-bold-extended']}
            font-size: 14px;
            line-height: 1.3em;
            text-transform: uppercase;
          }

          a:hover {
            color: ${brand.red.base};
            text-decoration: underline;
            text-underline-offset: 2px;
          }
        }
      }
    }
  }
`;

const TradeDropdownStyles = {
  Container,
  Column,
};

export default TradeDropdownStyles;
